import React, { Component } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Input } from '@progress/kendo-react-inputs';
import axios from 'axios'
import { ROOT_API_URL } from '../../../../../api-config';
import { auth } from '../../../../../services/auth.service';

class ProductTypeForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			productTypeInEdit: this.props.dataItem || null,
            value: [],
            originalDescription: this.props.dataItem.Description || '',
            descriptionMsg:''
		};
	}

	componentDidMount() {
		
	}

	handleSubmit = (event) => {
		event.preventDefault();
        if (this.state.originalDescription != this.state.productTypeInEdit.Description) {
            axios
				.post(`${ROOT_API_URL}/ManageProductType/IsProductTypeExist`, this.state.productTypeInEdit, { headers: auth.authHeader() })
                .then((response) => {
                    this.setState({
                        descriptionMsg: response.data.message
                    })

                    if (this.state.descriptionMsg == "") {
                        this.props.save({
                            ...this.state.productTypeInEdit
                        });
                        this.props.cancel();
                    }
                })
                .catch((response) => {
                    console.log(response);
                });
        }
        else {
            this.props.save({
                ...this.state.productTypeInEdit
            });
            this.props.cancel();
        }
	};
	isCustom(item) {
		return item.id === undefined;
	}
	addKey(item) {
		item.id = new Date().getTime();
	}
	onDialogInputChange = (event) => {
        let target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.props ? target.props.name : target.name;

		const edited = this.state.productTypeInEdit;
		edited[name] = value;
		edited.isActive = true;
		this.setState({
            productTypeInEdit: edited,
            descriptionMsg: ""
		});
    };
    
    
	render() {
		return (
			<Dialog onClose={this.props.cancel}>
			{console.log(this.state,"productType state")}
				{!this.state.productTypeInEdit.ProductTypeId ?
                    <h2 className="adjust-dist-title">Add New Product Type</h2> :
                    <h2 className="adjust-dist-title">Edit Product Type</h2>}
				<form className="user-form" onSubmit={this.handleSubmit}>
					<div className="form-group col-md-12 col-lg-7 row">
                        <label htmlFor="Description">Description</label>
						<Input
							required={true}
							type="text"
							name="Description"
							id="Description"
							value={this.state.productTypeInEdit.Description || ''}
							onChange={this.onDialogInputChange}
                        />
                        <p className="error-message">{this.state.descriptionMsg}</p>
					</div>
                    <div className="col-lg-5"></div>
					<DialogActionsBar>
                        <div className="adjust-btns">
							<div className="form-group">
								<button className="admin-k-button" onClick={this.props.cancel}>
									<i className="fas fa-times"></i>
									<span>CANCEL</span>
								</button>
								{!this.state.productTypeInEdit.productTypeId ? (
									<button type="submit" className="admin-k-button">
										<i className="fas fa-save"></i>
										<span>SAVE</span>
									</button>
								) : (
									<button type="submit" className="admin-k-button">
										<i className="fas fa-edit"></i>
										<span>UPDATE</span>
									</button>
								)}
							</div>
						</div>
					</DialogActionsBar>
				</form>
			</Dialog>
		);
	}
}

export default ProductTypeForm;
